<template>
  <div class="login-wrap">
    <pwd-notice v-if="pwdMsg"></pwd-notice>
    <div class="login-top">
      <login-top />
      <div class="content-part">
        <div class="passWorldTip" >
          <div class="flex">
            <img src="@/assets/img/Rules.png" class="tips-icon">
            <div v-html="$t('login_password_hints')"></div>
          </div>
          <div class="flex my-20">
            <img src="@/assets/img/Note.png" class="tips-icon">
            <div v-html="$t('login_password_note')"></div>
          </div>
        </div>
        <div class="ms-login">
          <div class="ms-title">{{$t('LOGIN_PAGE_CHANGE_TITLE')}}</div>
          <el-form :model="param"
                   :rules="rules"
                   ref="login"
                   label-width="0px"
                   class="ms-content">
            <el-form-item style="margin-top: 0px"
                          class="item checkAccount"
                          prop="account">
              <div class="label label-active">{{ $t('login_account') }}</div>
              <el-input readonly
                        v-model="param.account"
                        :placeholder="$t('login_account')">
              </el-input>
            </el-form-item>
            <el-form-item class="item"
                          prop="oldPassword">
              <div :class="oldPwdFocus ? 'label label-active' : 'label'" @click="() => { $refs.oldPassword.focus() }">{{ $t('login_old_passWorld') }}</div>
              <el-input show-password
                        ref="oldPassword"
                        v-model="param.oldPassword"
                        @focus="oldPwdFocus = true">
              </el-input>
            </el-form-item>
            <el-form-item class="item"
                          prop="newPassword" style="margin-bottom: 0.27rem;">
              <div :class="newPwdFocus ? 'label label-active' : 'label'" @click="() => { $refs.newPassword.focus() }">{{ $t('login_new_passWorld') }}</div>
              <el-input show-password
                        @blur="newPasswordChange"
                        ref="newPassword"
                        v-model="param.newPassword"
                        @focus="newPwdFocus = true">
              </el-input>
            </el-form-item>
            <el-form-item class="item"
                          prop="reNewPassword" style="margin-bottom: 0.27rem;">
              <div :class="reNewPwdFocus ? 'label label-active' : 'label'" @click="() => { $refs.reNewPassword.focus() }">{{ $t('login_renew_passWorld') }}</div>
              <el-input show-password
                        ref="reNewPassword"
                        @keyup.enter.native="submitForm()"
                        v-model="param.reNewPassword"
                        @focus="reNewPwdFocus = true">
              </el-input>
            </el-form-item>
            <div class="footer-login">
              <el-button class="login-btn login-item back"
                         type="primary"
                         @click="back2History()">
                {{$t('login_btn_back')}}
              </el-button>
              <el-button :loading="loginLoading"
                         class="login-btn login-item save"
                         type="primary"
                         @click="submitForm()">
                {{$t('login_btn_confirm')}}
              </el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <v-bottom></v-bottom>
  </div>
</template>

<script>
    import API from '@/api'
    import VBottom from '@/components/common/Bottom.vue'
    import {encryptForGCM, UserInput} from '@/utils/index'
    import {mapGetters} from 'vuex'
    import LoginTop from '@/components/common/LoginTop'
    import PwdNotice from '@/components/common/PwdNotice.vue'

    export default {
        data () {
            return {
                user: '',
                loginLoading: false,
                param: {
                    account: '',
                    oldPassword: '',
                    newPassword: '',
                    reNewPassword: '',
                },
              oldPwdFocus: false,
              newPwdFocus: false,
              reNewPwdFocus: false,
              pwdMsg: false,
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser',
                getIsFirstLogin: 'getIsFirstLogin'
            }),
            rules() {
                const rules = {
                    account: [{required: true, message: this.$t('FORM_VALIDATE_ACCOUNT'), trigger: 'blur'}],
                    oldPassword: [
                        {required: true, message: this.$t('FORM_VALIDATE_OLD_PASSWORD'), trigger: 'blur'},
                        // {
                        //     pattern: UserInput.reg2,
                        //     trigger: 'blur',
                        //     message: this.$t('ILLEGAL_USER_INPUT_03')
                        // },
                        // {min: 12, max: 100, message: this.$t('FORM_VALIDATE_LOGIN_MAX'), trigger: 'blur'}
                    ],
                    newPassword: [
                        {required: true, message: this.$t('FORM_VALIDATE_NEW_PASSWORD'), trigger: 'blur'},
                        {
                            pattern: UserInput.reg2,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_03')
                        },
                        {min: 12, max: 100, message: this.$t('FORM_VALIDATE_LOGIN_MAX'), trigger: 'blur'}
                    ],
                    reNewPassword: [
                        {
                            pattern: UserInput.reg2,
                            trigger: 'blur',
                            message: this.$t('ILLEGAL_USER_INPUT_03')
                        },
                        {min: 12, max: 100, message: this.$t('FORM_VALIDATE_LOGIN_MAX'), trigger: 'blur'},
                        {validator: this.validatePass2, trigger: 'blur'},

                    ]
                }
                return rules
            }
        },
        methods: {
          checkAccount() {
              if (this.param.account) {
                API.common.checkAccount({ param: this.param.account }).then((res) => {
                  if (res.code === '1') {
                    this.pwdMsg = res.data.oldPwdFlag
                  }
                })
              }
            },
            validatePass2(rule, value, callback) {
                if (value === '') {
                    callback(new Error(this.$t('FORM_VALIDATE_RENEW_PASSWORD')))
                } else if (value !== this.param.newPassword) {
                    callback(new Error(this.$t('FORM_VALIDATE_NEW_PASSWORD_INCONSISTEN')))
                } else {
                    callback()
                }
            },
            newPasswordChange() {
                if (this.param.newPassword) {
                    this.$refs.login.validateField('reNewPassword')
                }
            },
            submitForm() {
                this.$refs.login.validate(valid => {
                    if (valid) {
                        this.loginLoading = true
                        const aesOldPswd = encryptForGCM(this.param.oldPassword, localStorage.getItem('aesKey'))
                        const aesNewPswd = encryptForGCM(this.param.newPassword, localStorage.getItem('aesKey'))
                        let params = {
                            userAccount: this.param.account,
                            oldPswd: aesOldPswd,
                            newPswd: aesNewPswd
                        }
                        API.common
                            .updataPassword(params)
                            .then(res => {
                                if (res.code == '1') {
                                    this.$store.commit('common/setIsFirstLogin', false)
                                    this.loginLoading = false
                                    this.$message.success('Success 成功')
                                    localStorage.removeItem('please_change_password')

                                    const _redirectUrl = JSON.parse(sessionStorage.getItem('redirectUrl'));
                                    _redirectUrl ? this.$router.replace({
                                      name: _redirectUrl.name,
                                      query: _redirectUrl.query
                                    }) : this.$router.push('/')
                                    sessionStorage.removeItem('redirectUrl')
                                } else if (res.code == 'CLIENT_USER_010') {
                                  this.$message({
                                    type: 'error',
                                    dangerouslyUseHTMLString: true,
                                    message: this.$t('CLIENT_USER_010')
                                  })
                                } else {
                                    this.$message.error(this.$t(res.code))
                                }
                            })
                            .catch(e => {
                              console.error(e);
                              this.$message.error(this.$t('SYS_USER_003'))
                            })
                            .finally(() => {
                            this.loginLoading = false
                        })
                    }
                })
            },
            back2History() {
                if (this.getIsFirstLogin || this.getUser.changePeriod >= 90) {
                    sessionStorage.removeItem('JSESSIONID')
                    localStorage.removeItem('JSESSIONID')
                    sessionStorage.removeItem('siteClassification')
                    this.$store.commit('common/setUser', {})
                    this.$store.commit('common/setSite', {})
                    this.$store.commit('common/setEntity', {})
                    this.$router.push('/login')
                } else {
                    this.$router.go(-1)
                }
            }
        },
        mounted() {
            this.user = this.getUser
            this.param.account = this.user.userAccount
            this.checkAccount()
            
        },
        components: {
          VBottom,
          LoginTop,
          PwdNotice
        },
        
    }
</script>

<style scoped>
  .login-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background: url("~@/assets/img/loginbg.png") center center/100% 100% no-repeat fixed;
  }

  .login-top {
    position: relative;
    width: 100%;
    height: 100%;
  }
.content-part{
  height: calc(100% - 193px);
  position: relative;
}
  .imglogo img {
    width: 1036px;
  }

  .ms-title {
    color: #00338d;
    font-size: 42px;
    line-height: 66px;
    font-family: 'KPMG Light', 'KPMG';
    margin-bottom: 30px;
  }

  .ms-login {
    position: absolute;
    right: 10%;
    top: 10%;
    width: 570px;
    height: 636px;
    background: #fff;
    overflow: hidden;
    border-radius: 8px;
    padding: 45px;
  }

  .ms-content .item {
    margin-bottom: 37px;
  }

  .ms-content .title {
    font-weight: 400;
    font-style: normal;
    font-size: 21px;
    color: #005eb8;
  }

  .login-tips {
    display: block;
    margin-top: 24px;
    font-weight: 400;
    font-style: normal;
    font-size: 21px;
    color: #005eb8;
    text-align: center;
  }

  .footer-login {
    margin: 0 auto;
    width: 480px;
    height: 60px;
  }

  .login-item {
    width: 219px;
    height: 60px;
    border: none;
    border-radius: 8px;
    background-color: #005eb8;
    font-size: 21px;
  }

  .back {
    color: #333;
    background-color: rgba(240, 240, 240, 1);
  }

  .save {
    margin-left: 42px !important;
  }

  .login-item:hover {
    background-color: #0091da;
  }

  .passWorldTip {
    width: 43%;
    position: absolute;
    right: calc(10% + 660px);
    font-size: 18px;
    color: #fff;
    line-height: 36px;
    border-radius: 5px;
    padding: 20px 40px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    height: 636px;
    top:10%;
    backdrop-filter: blur(10px);
  }
  ::v-deep .el-input__inner {
    font-size: 16PX !important;
  }
  .tips-icon{
    width: 40px;
    height: 40px;
    margin-right: 20px;
  }

</style>
